<template>
  <v-row justify="center">
    <v-dialog :value="value" @input="$emit('input')" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Duplicar incidencia</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12">

              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="$emit('input')">Cerrar</v-btn>
          <v-btn color="primary" @click.native="updateStatus()">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: {
    value: Boolean,
    singleItem: Array
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style scoped>

</style>
